module.exports = __webpack_public_path__ + "static/twitter-c492f58065eb5e586f7276f5e3afde6f.svg";